var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('v-content',{staticStyle:{"margin":"12xp","padding":"0"}},[_c('slc-help-menu',{attrs:{"is-mobile":true,"links-config":_vm.linksConfig}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }